module.exports = __webpack_public_path__ + "static/media/ico-not-chosen.61d606b0.svg";